import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { DocoService } from './services/doco.service';
import { FileService } from './services/file.service';
import { FlightService } from './services/flight.service';
import { ImageService } from './services/image.service';
import { PegasusService } from './services/pegasus.service';
import { SocketService } from './services/socket.service';
import { ToastService } from './services/toast.service';
import { ToolbarService } from './services/toolbar.service';
import { TrolleyService } from './services/trolley.service';
import { UserService } from './services/user.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule
  ],
  providers: [
    AuthService,
    ToastService,
    AuthGuardService,
    ToolbarService,
    FileService,
    ImageService,
    FlightService,
    TrolleyService,
    UserService,
    PegasusService,
    DocoService,
    SocketService
  ]
})
export class CoreModule { }
